import React from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FormattedHelmet from "../cmp/intl/FormattedHelmet";
import CreativesGrid from "./creatives/CreativesGrid";
import FileUploadMarketingPage from "./fileupload/FileUploadMarketingPage";
import AssetFolders from "./help/components/AssetFolders";
import ProductLinksSection from "./marketing-tools/ProductLinksSection";

const SocialMediaTools = React.lazy(
  () => import("./marketing-tools/social-media-tools/SocialMediaTools"),
);

function OffersPage({
  aff_product_linker,
  aff_file_upload,
  aff_media_assets,
  link_type,
  default_asset_folders,
}) {
  const sm_tools_enabled = useSelector(
    (state) => state.settings.sm_tools_enabled,
  );
  const contacts_crm_enabled = useSelector((state)=>state.settings.contacts_crm_enabled)
  return (
    <>
      <FormattedHelmet id={"Marketing Tools"} />
      <div className={"mb-4"}>
        {contacts_crm_enabled ? (
          <div className="space-between mb-4">
            <div>
              <h3 className="mb-1">Contacts</h3>
              <p className="mb-0 text-muted">
                Manage and market to your customers
              </p>
            </div>
            <Link to="/contacts" className="btn btn-sm btn-outline-primary">
              View Contacts
            </Link>
          </div>
        ) : null}
        {sm_tools_enabled ? <SocialMediaTools /> : null}
        {aff_product_linker && link_type > -1 && <ProductLinksSection />}
        {aff_file_upload && <FileUploadMarketingPage />}
        {aff_media_assets ? (
          <>
            {aff_media_assets === "assets" ||
            aff_media_assets === "assets_list" ? (
              <div className="mt-3">
                <AssetFolders
                  asset_folders={default_asset_folders}
                  display_as={
                    aff_media_assets === "assets_list" ? "list" : "grid"
                  }
                />
              </div>
            ) : (
              <CreativesGrid />
            )}
          </>
        ) : null}
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const {
    is_redirect,
    show_site_stripe,
    website,
    ref_code,
    subscription,
    aff_file_upload,
    aff_show_product_commissions,
    default_asset_folders,
  } = state.settings;
  return {
    link_type: Number(is_redirect),
    show_site_stripe,
    website,
    ref_code,
    subscription,
    aff_file_upload,
    aff_show_product_commissions,
    aff_media_assets:
      state.settings.aff_media_assets === undefined
        ? true
        : state.settings.aff_media_assets,
    aff_product_linker:
      state.settings.aff_product_linker === undefined
        ? true
        : state.settings.aff_product_linker,
    default_asset_folders,
  };
}

export default connect(mapStateToProps)(OffersPage);
